module.exports = __webpack_public_path__ + "static/10-5f06e0a3b29ce0a0af23cc92825aeeb4.jpg";